export const getCongratulationsSmartbox = async (data) =>{
    
    const displaySmartboxWithPreloader = (await import(/* webpackPrefetch: true */ "../display/displaySmartboxWithPreloader.js")).displaySmartboxWithPreloader;
    const getCongratulationHeading = (await import(/* webpackPrefetch: true */ "./getCongratulationHeading")).getCongratulationHeading;


    const { preloader, smetioSmartbox } = await displaySmartboxWithPreloader({ title: "txt118" });

    preloader.hide();

    const content = await getCongratulationHeading(data);

    smetioSmartbox.updateContent(content);

};
